<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import PageHeader from "../components/PageHeader.svelte";
    import {formatDate} from "../lib/lib";
    import Alert from "../stores/alerts";
    import Checkbox from "../components/controls/Checkbox.svelte";

    let importData = "";
    let list = [];
    let listIndex = -1;
    let listOffset = 10;
    let totalCreated = 0;
    let totalUpdated = 0;
    let totalErrors = 0;
    let checkMode = 'name';
    let doubles = [];

    // 0: Κωδικός
    // * 1: Επωνυμία
    // * 2: ΑM
    // * 3: Συνδρομές
    // * 4: Α.Φ.Μ.
    // * 5: Δ.Ο.Υ.
    // * 6: Επάγγελμα
    // * 7: e-mail
    // * 8: Διεύθυνση
    // * 9: Πόλη
    // * 10: Περιοχή (region)
    // * 11: T.K.
    // * 12: Σταθερό (phone1)
    // * 13: Τηλέφωνο3 (phone2)
    // * 14: Κινητό
    // * 15: Τόπος Γέννησης
    // * 16: Σχόλια (notes)
    // * 17: Ημ. Γέννησης
    // * 18: Ημ. Αποφοίτησης
    // * 19: Ετος Εγγραφής
    // * 20: Πανεπιστήμιο
    // * 21: Παράρτημα
    // * 22: Αιτιολογία


    const parseLine = lineData => {
        let line = lineData.split("\t");
        if (!line) {
            return;
        }

        let record = {
            code: '',
            lastname: '',
            firstname: '',
            birthday: null,
            birth_place: '',
            email: '',
            phone1: '',
            phone2: '',
            mobile: '',
            afm: '',
            doy: '',
            occupation_type: 0,
            address: '',
            city: '',
            post_code: '',
            region_id: 0,
            university: '',
            university_branch: '',
            graduated_at: null,
            registration_year: null,
            rationale: '',
        };

        let name = line[1];
        let afm = line[4];
        if (afm.length < 9) afm = '';

        let arr = name.split(' ');

        record.code = line[2];
        record.lastname = arr.shift();
        record.firstname = arr.join(" ");
        record.afm = afm;
        record.doy = line[5];
        record.occupation_type = getOccupationType(line[6]);

        record.email = line[7];
        record.phone1 = line[12];
        record.phone2 = line[13];
        record.mobile = line[14];

        record.birthday = fixDate(line[17]);
        record.birth_place = line[15];

        record.address = line[8];
        record.city = line[9];
        record.post_code = line[11];
        record.region_id = getRegionId(line[10]);
        record.region = line[10];

        let university = line[20];
        if (university) {
            university = university.replace("ΠΑΝΕΠΙΣΤΗΜΙΟ :", "");
            university = university.replace("ΠΑΝΕΠΙΣΤΗΜΙΟ:", "").trim();
        }
        record.university = university;
        record.university_branch = line[21];
        record.graduated_at = fixDate(line[18], '2000-32-12');
        record.registration_year = line[19];


        record.subscription = line[3];

        record.rationale = line[22];
        record.notes = line[16];

        list.push(record);
    }


    const parseData = () => {
        list = [];
        let listData = importData.split("\n");
        for (let i = 0; i < listData.length; i++) {
            if (listData[i]) {
                parseLine(listData[i]);
            }
        }
        check();
    }

    const clearData = () => {
        importData = '';
        list = [];
        listIndex = -1;
        doubles = [];
    }

    const save = () => {
        listIndex = 0;
        totalCreated = 0;
        totalUpdated = 0;
        totalErrors = 0;
        if (!list.length) {
            Alert.warning("Εισαγωγή", "Δεν υπάρχουν στοιχεία για εισαγωγή.");
            return;
        }
        saveNext();
    }

    const saveNext = () => {
        const onSuccess = result => {
            totalCreated += ~~result.total_created;
            totalUpdated += ~~result.total_updated;
            totalErrors += ~~result.total_errors;
            listIndex += listOffset;
            saveNext();
        }

        const onFailure = err => {
            Alert.warning("Εισαγωγή μελών", "Απέτυχε!");
        };

        if (listIndex < 0) {
            return;
        }
        if (listIndex >= list.length) {
            importCompleted();
            return;
        }

        let data = list.slice(listIndex, listIndex + listOffset);
        if (!data.length) {
            importCompleted();
            return;
        }

        R.handle(R.import.import, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const stop = () => {
        listIndex = -1;
    }

    const importCompleted = () => {
        listIndex = -1;
        Alert.alert("Εισαγωγή", `Η εισαγωγή ολοκληρώθηκε.\n\nΔημιουργήθηκαν: ${totalCreated}\nΕνημερώθηκαν: ${totalUpdated}\nΣφάλματα: ${totalErrors}`);
    }


    const check = () => {
        const onSuccess = result => {
            let member;

            result.list.map(item => {
                member = list.find(x => x.code === item.code);
                if (member) {
                    member.id = ~~item.id;
                }
            });

            doubles = result.doubles;
            // doubles.map(item => {
            //     member = list.find(x => x.code === item.code);
            //     if (member) {
            //         member.is_double = true;
            //         member.code = "_" + member.code;
            //     }
            // });

            list = list;
        }

        const onFailure = err => {

        };

        // let data = list.map(item => (item.code));
        let data = {
            check_mode: checkMode,
            list: [],
        };
        list.map(item => {
            if (item.code) {
                data.list.push({code: item.code, lastname: item.lastname, firstname: item.firstname, afm: item.afm});
            }
        });

        R.handle(R.import.check, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const fixDate = (date, max_date = null) => {
        if (!date) {
            return null;
        }

        let dt = formatDate(date, 'y-m-d');
        if (!dt) {
            return null;
        }

        if (dt <= '1900-01-01') {
            return null;
        }

        if (max_date && dt > max_date) {
            return null;
        }

        return dt;
    }

    const getOccupationType = occupation => {
        if (occupation === 'ΔΗΜΟΣΙΟ') {
            return 1;
        }
        if (occupation === 'ΙΔΙΩΤΗΣ') {
            return 2;
        }
        if (occupation === 'ΜΙΣΘΩΤΟΣ') {
            return 3;
        }
        return 0;
    }

    const getRegionId = (name) => {
        let id = 0;
        $app.regions.map(item => {
            if (id == 0) {
                if (item.name === name) {
                    id = item.id;
                } else {
                    if (item.match_name.includes(name)) {
                        id = item.id;
                    }
                }
            }
        });

        return id;
    }

</script>

<PageHeader title="Εισαγωγή"/>
<div class="panel panel-simple panel-pad mb-4">
    <div class="form-group">
        <textarea class="form-control" bind:value={importData}></textarea>
    </div>
    <div class="form-group">
        <select class="form-select" bind:value="{checkMode}">
            <option value="name">Έλεγχος με όνομα</option>
            <option value="afm">Έλεγχος με ΑΦΜ</option>
        </select>
    </div>
    {#if doubles.length}
        <div class="alert alert-danger">
            <p><strong>Διπλές Εγγραφές</strong></p>
            <table>
                {#each doubles as item}
                    <tr>
                        <td class="px-2">{ item.code }</td>
                        <td class="px-2">{ item.src }</td>
                        <td class="px-2">{ item.dst }</td>
                    </tr>
                {/each}
            </table>
        </div>
    {/if}
    <button class="btn btn-primary" on:click={parseData}>Εκτέλεση</button>
    <button class="btn btn-default" on:click={clearData}>Καθαρισμός</button>
</div>

<div class="table-responsive mb-4">
    <table class="table table-list table-sm">
        <thead>
        <tr>
            <th>Α.Μ.</th>
            <th>Επίθετο</th>
            <th>Όνομα</th>
            <th>Email</th>
            <th>Τηλ1</th>
            <th>Τηλ2</th>
            <th>Κινητό</th>
            <th>ΑΦΜ</th>
            <th>ΔΟΥ</th>
            <th>Επάγγελμα</th>
            <th>Διεύθυνση</th>
            <th>Πόλη</th>
            <th>ΤΚ</th>
            <th>Νομός</th>
            <th>Ημ. Γέννησης</th>
            <th>Τόπ. Γέννησης</th>

            <th>Πανεπιστήμιο</th>
            <th>Παράρτημα</th>
            <th>Ημ. Αποφ.</th>
            <th>Έτος Εγγρ.</th>
            <th>Αιτιολογία</th>

            <th>Συνδρ.</th>
            <th>Σημειώσεις</th>
        </tr>
        </thead>
        <tbody>
        {#if list.length}
            {#each list as item}
                <tr class:line-error={!item.code}>
                    <td class:member-create={item.id < 1}
                        class:member-update={item.id > 0}
                        class:member-double={item.is_double}
                    >
                        { item.code }
                    </td>
                    <td>{ item.lastname }</td>
                    <td>{ item.firstname }</td>
                    <td>{ item.email }</td>
                    <td>{ item.phone1 }</td>
                    <td>{ item.phone2 }</td>
                    <td>{ item.mobile }</td>
                    <td>{ item.afm }</td>
                    <td>{ item.doy }</td>
                    <td>{ item.occupation_type }</td>
                    <td>{ item.address }</td>
                    <td>{ item.city }</td>
                    <td>{ item.post_code }</td>
                    <td>{ item.region } - { item.region_id }</td>
                    <td>{ item.birthday }</td>
                    <td>{ item.birth_place }</td>
                    <td>{ item.university }</td>
                    <td>{ item.university_branch }</td>
                    <td>{ item.graduated_at }</td>
                    <td>{ item.registration_year }</td>
                    <td>{ item.rationale }</td>
                    <td>{ item.subscription  }</td>
                    <td>{ item.notes }</td>
                </tr>
            {/each}
        {/if}
        </tbody>
    </table>
</div>
<button class="btn btn-primary" on:click={save}>Ενημέρωση</button>
<button class="btn btn-default" on:click={stop}>Stop</button>

<style>
    .line-error {
        background: rgba(255, 0, 0, 0.2);
    }

    .member-create {
        border-left: 4px solid #00ff00;
    }

    .member-update {
        border-left: 4px solid #0000ff;
    }

    .member-double {
        border-left: 4px solid #ff0000 !important;
    }
</style>